// Development environment — deployed to dev.kilowant.com.
//
// Selected by `ng build --configuration development` (the build the
// post-commit deploy hook runs) and `ng serve --configuration development`.
// Swapped in for environment.ts via fileReplacements in angular.json.
//
// Keep keys in sync (same keys, same order) with environment.ts.

export const environment = {
    production: true,
    WEB_API_URL: "https://dev.kilowant.com/api/",
    WEB_SITE_URL: "https://dev.kilowant.com",
    RECS_PER_PAGE: 25,
    BILL_PARSE_LENGTH: 15,
    KILOWANT_COLOR: "ffcf00",
    RI_UTILITY_COLOR: "001489",
    RI_UTILITY_FORECASTED_COLOR: "7c7daa",
    RI_COMMUNITY_COLOR: "0096D6",
    RI_COMMUNITY_FORECASTED_COLOR: "7cb2df",
    GOOGLE_MAPS_API_KEY: 'AIzaSyA80ssjcTdVAtTpMU5Lb_KAYNtbKj8Rdqw',
    GA4_MEASUREMENT_ID: "G-H20XVTKFY5",
    GA4_DEBUG: true,
};
